/* Native variant CARD picker — cross-option updates.
   For multi-option products (e.g. Size × Style), when a NON-card option changes (Size), each Style
   card's price / sale badge / availability / image is recomputed from the variant matching the full
   current selection. Selection itself is native radios inside Dawn's <variant-selects>, so Dawn keeps
   driving the main price / gallery / add-to-cart. Single-option products need none of this (each card
   is one variant) — this simply no-ops for them.
   Also upgrades any "Single or Set" bundle <select> into a thumbnail dropdown (NvcDropdown). */
(function () {
  function esc(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\\]]/g, '\\$&');
  }
  class NvcCards {
    constructor(root) {
      this.root = root; // <variant-selects>
      const dataEl = root.querySelector('[data-nvc-variants]');
      const cardFs = root.querySelector('.product-form__input--card[data-nvc-card-position]');
      if (!dataEl || !cardFs) return;
      try { this.variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      this.cardFs = cardFs;
      this.cardPos = parseInt(cardFs.dataset.nvcCardPosition, 10);
      this.onChange = this.refresh.bind(this);
      root.addEventListener('change', this.onChange);
      this.refresh();
    }
    selected() {
      const map = {};
      this.root.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
        const pos = parseInt(String(i.name).split('-').pop(), 10);
        if (pos) map[pos] = i.value;
      });
      // also read <select> options (e.g. the "Single or Set" bundle) by their option position,
      // so card price/image recompute against the full selection, not just the radio options.
      this.root.querySelectorAll('select[data-nvc-option-pos]').forEach(function (s) {
        const pos = parseInt(s.getAttribute('data-nvc-option-pos'), 10);
        if (pos) map[pos] = s.value;
      });
      return map;
    }
    variantFor(cardValue, sel) {
      const cp = this.cardPos;
      return this.variants.find(function (v) {
        const vv = { 1: v.o1, 2: v.o2, 3: v.o3 };
        if (vv[cp] !== cardValue) return false;
        for (const pos in sel) {
          const p = parseInt(pos, 10);
          if (p === cp) continue;
          if (vv[p] != null && vv[p] !== sel[pos]) return false;
        }
        return true;
      });
    }
    refresh() {
      const sel = this.selected();
      const self = this;
      let firstAvailRadio = null;
      let selectedOk = false;
      this.cardFs.querySelectorAll('.nvc-card').forEach(function (card) {
        const val = card.getAttribute('data-card-value');
        const radio = self.cardFs.querySelector('input[value="' + esc(val) + '"]');
        const priceEl = card.querySelector('[data-card-price]');
        const badgeEl = card.querySelector('[data-card-badge]');
        const imgEl = card.querySelector('.nvc-card__media img');
        const v = self.variantFor(val, sel);
        const unavailable = !v || !v.avail;
        card.classList.toggle('is-unavailable', unavailable);
        if (radio) {
          radio.classList.toggle('disabled', unavailable);
          if (!unavailable && !firstAvailRadio) firstAvailRadio = radio;
          if (radio.checked && !unavailable) selectedOk = true;
        }
        if (!v) return;
        if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
        if (badgeEl) {
          if (v.cc && v.pc && v.cc > v.pc) {
            var _fmt = (self.root && self.root.getAttribute('data-nvc-badge-format')) || 'percent';
            if (_fmt === 'sale') { badgeEl.textContent = 'SALE'; }
            else if (_fmt === 'save_amount') { badgeEl.textContent = 'SAVE $' + Math.round(v.cc - v.pc); }
            else { var _pct = (v.cc - v.pc) * 100 / v.cc; var _band = Math.round(_pct / 5) * 5; if (_pct - _band > 1) _band = Math.ceil(_pct); if (_band <= 0) _band = Math.round(_pct); badgeEl.textContent = _band + '% OFF'; }
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
        if (imgEl) {
          const fb = imgEl.getAttribute('data-nvc-fallback') || '';
          if (v.img) {
            const want = v.img + (v.img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
            if (imgEl.getAttribute('src') !== want) {
              if (fb) imgEl.onerror = function () { this.onerror = null; if (this.getAttribute('src') !== fb) this.src = fb; };
              imgEl.src = want; imgEl.removeAttribute('srcset');
            }
          } else if (fb && imgEl.getAttribute('src') !== fb) {
            imgEl.src = fb; imgEl.removeAttribute('srcset');
          }
        }
      });
      if (!selectedOk && firstAvailRadio && !this._auto) {
        this._auto = true;
        firstAvailRadio.checked = true;
        firstAvailRadio.dispatchEvent(new Event('change', { bubbles: true }));
        this._auto = false;
      }
    }
  }

  /* Thumbnail dropdown for the "Single or Set" bundle option. Wraps the native <select> (kept for
     Dawn/form submit, hidden) with a button + panel showing each variant's image, name and price.
     COLOUR-REACTIVE: when another option (e.g. the Walnut/Natural toggle) changes, each bundle
     option's thumbnail is recomputed from the variant matching the FULL current selection, so the
     preview images follow the chosen colour instead of being stuck on the default colour. */
  class NvcDropdown {
    constructor(container) {
      this.container = container;
      this.select = container.querySelector('select');
      if (!this.select || this.select.__nvcdd) return;
      this.select.__nvcdd = true;
      // parent <variant-selects> + full variant data, so option thumbnails can follow the colour choice
      this.root = container.closest('variant-selects');
      this.optionPos = parseInt(this.select.getAttribute('data-nvc-option-pos'), 10) || 0;
      this.variants = null;
      if (this.root) {
        const dataEl = this.root.querySelector('[data-nvc-variants]');
        if (dataEl) { try { this.variants = JSON.parse(dataEl.textContent); } catch (e) {} }
      }
      // never-blank fallbacks: remember the last good image we showed per option value
      this._lastImg = {};
      this.build();
      this.select.addEventListener('change', this.sync.bind(this));
      // recompute thumbnails whenever ANY option in the picker changes (e.g. the colour toggle)
      if (this.root) this.root.addEventListener('change', this.refreshImages.bind(this));
    }
    currentSelection() {
      const map = {};
      if (!this.root) return map;
      this.root.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
        const pos = parseInt(String(i.name).split('-').pop(), 10);
        if (pos) map[pos] = i.value;
      });
      this.root.querySelectorAll('select[data-nvc-option-pos]').forEach(function (s) {
        const pos = parseInt(s.getAttribute('data-nvc-option-pos'), 10);
        if (pos) map[pos] = s.value;
      });
      return map;
    }
    // Image for a bundle option value, matched against the CURRENT colour/other selections. Prefers the
    // exact (colour + bundle) variant image; if that variant has no image, falls back to any variant of
    // the current colour (so Natural still shows a Natural thumbnail), then to the option's static attr.
    imageFor(optValue) {
      if (!this.variants || !this.optionPos) return '';
      const pos = this.optionPos;
      const target = this.currentSelection();
      target[pos] = optValue;
      const findMatch = function (relaxBundle) {
        return this.variants.find(function (v) {
          const vv = { 1: v.o1, 2: v.o2, 3: v.o3 };
          for (const p in target) {
            const pp = parseInt(p, 10);
            if (relaxBundle && pp === pos) continue;
            if (vv[pp] != null && vv[pp] !== target[p]) return false;
          }
          return true;
        });
      }.bind(this);
      let v = findMatch(false);
      if (!v || !v.img) { const v2 = findMatch(true); if (v2 && v2.img) v = v2; }
      if (!v || !v.img) return '';
      return v.img + (v.img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }
    // The currently-selected variant's image (Dawn's data-selected-variant), else the main gallery image.
    // Always available, so it's the last-resort fallback that guarantees the thumbnail never blanks.
    currentImg() {
      if (this.root) {
        const sv = this.root.querySelector('[data-selected-variant]');
        if (sv) {
          try {
            const v = JSON.parse(sv.textContent);
            const src = (v && v.featured_image && (v.featured_image.src || v.featured_image))
              || (v && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
            if (src) return src;
          } catch (e) {}
        }
      }
      const g = document.querySelector('.product__media img, .product-media img, media-gallery img, .product__media-item img');
      return g ? (g.currentSrc || g.src || '') : '';
    }
    // Resolve an option's thumbnail with a strict never-blank fallback chain:
    //   1) exact colour/type + bundle variant image (colour-reactive)
    //   2) the option's static data-nvc-img (rendered by liquid)
    //   3) the last good image we showed for this option
    //   4) the current variant / gallery image (always present)
    // Whatever we resolve is cached as this option's last-good, so it can never regress to empty.
    resolveImg(opt) {
      const key = opt.value;
      let img = this.imageFor(key) || opt.getAttribute('data-nvc-img') || this._lastImg[key] || this.currentImg() || '';
      if (img) this._lastImg[key] = img;
      return img;
    }
    // Price for a bundle option, recomputed from the variant matching the FULL current selection
    // (Type + Colour + this bundle value) — so the pill and every dropdown row follow the Type/Colour
    // toggle instead of showing a stale price baked in by liquid for one fixed Type. Falls back to the
    // option's static data-nvc-price if no exact variant match.
    priceFor(optValue) {
      if (!this.variants || !this.optionPos) return '';
      const pos = this.optionPos;
      const target = this.currentSelection();
      target[pos] = optValue;
      const v = this.variants.find(function (vv) {
        const o = { 1: vv.o1, 2: vv.o2, 3: vv.o3 };
        for (const p in target) { const pp = parseInt(p, 10); if (o[pp] != null && o[pp] !== target[p]) return false; }
        return true;
      });
      return v && v.price_html ? v.price_html : '';
    }
    _html(opt, img, isTrigger) {
      const price = this.priceFor(opt.value) || opt.getAttribute('data-nvc-price') || '';
      const name = opt.value || opt.textContent.trim();
      // NB: no loading="lazy" — these are tiny, always-visible thumbnails, and a lazy-loaded <img>
      // re-inserted by JS after an interaction gets SKIPPED by the lazy loader (stuck at naturalWidth 0
      // = blank). Rendering them eagerly is the actual fix for the "pill goes text-only after you
      // interact" regression (confirmed in-browser on US).
      return (img ? '<img class="nvc-dd-img" src="' + img + '" alt="" decoding="async">' : '<span class="nvc-dd-img nvc-dd-img--ph"></span>')
        + '<span class="nvc-dd-name">' + name + '</span>'
        + (price ? '<span class="nvc-dd-price">' + price + '</span>' : '')
        + (isTrigger ? '<span class="nvc-dd-caret" aria-hidden="true">▾</span>' : '');
    }
    // GUARDED render: NEVER overwrite an existing thumbnail with an empty value. If resolveImg can't
    // produce an image for this selection (e.g. a US variant combo with no image in the data), keep the
    // image already shown (or the last good one). This makes the pill/trigger impossible to blank after
    // the correct server-rendered image, while still swapping to a real image whenever one is found.
    _paint(el, opt, isTrigger) {
      if (!el || !opt) return;
      const prevEl = el.querySelector('img.nvc-dd-img');
      const prevSrc = prevEl ? prevEl.getAttribute('src') : (this._lastImg[opt.value] || '');
      const img = this.resolveImg(opt) || prevSrc || '';        // guard: fall back to the existing image
      if (img) this._lastImg[opt.value] = img;
      el.innerHTML = this._html(opt, img, isTrigger);
      // if the (possibly new) image URL fails to load, revert to the previously shown image, don't blank
      const im = el.querySelector('img.nvc-dd-img');
      if (im) { const self2 = this; im.onerror = function () { this.onerror = null; const fb = prevSrc || self2.currentImg() || ''; if (fb && this.getAttribute('src') !== fb) this.setAttribute('src', fb); }; }
    }
    build() {
      this.select.classList.add('nvc-native-hidden');
      const wrap = document.createElement('div'); wrap.className = 'nvc-dd';
      this.trigger = document.createElement('button');
      this.trigger.type = 'button'; this.trigger.className = 'nvc-dd-trigger'; this.trigger.setAttribute('aria-haspopup', 'listbox');
      this.panel = document.createElement('div'); this.panel.className = 'nvc-dd-panel'; this.panel.setAttribute('role', 'listbox');
      const self = this;
      Array.from(this.select.options).forEach(function (opt, i) {
        const row = document.createElement('button');
        row.type = 'button'; row.className = 'nvc-dd-opt'; row.setAttribute('role', 'option');
        self._paint(row, opt, false);
        if (opt.disabled) row.setAttribute('aria-disabled', 'true');
        row.addEventListener('click', function () {
          if (opt.disabled) return;
          self.select.selectedIndex = i;
          self.select.dispatchEvent(new Event('change', { bubbles: true }));
          self.close();
        });
        self.panel.appendChild(row);
      });
      this.trigger.addEventListener('click', function (e) { e.preventDefault(); self.toggle(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) self.close(); });
      wrap.appendChild(this.trigger); wrap.appendChild(this.panel);
      this.select.parentNode.appendChild(wrap);
      this.sync();
    }
    // Re-render each option's thumbnail (and the trigger) against the current selection — called when
    // any option changes, so the colour toggle updates the bundle dropdown previews.
    refreshImages() {
      if (!this.panel) return;
      const rows = this.panel.querySelectorAll('.nvc-dd-opt');
      const self = this;
      Array.from(this.select.options).forEach(function (opt, i) {
        if (rows[i]) self._paint(rows[i], opt, false);
      });
      this.sync();
    }
    sync() {
      const opt = this.select.options[this.select.selectedIndex];
      if (opt) this._paint(this.trigger, opt, true);
    }
    toggle() { this.panel.classList.toggle('open'); }
    close() { this.panel.classList.remove('open'); }
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(function (el) {
      if (!el.__nvc) el.__nvc = new NvcCards(el);
    });
    document.querySelectorAll('.nvc-thumb-dropdown').forEach(function (el) {
      if (!el.__nvcdd) { el.__nvcdd = true; new NvcDropdown(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  // CRITICAL: when Dawn re-renders the product form on a variant change (its Section Rendering API),
  // it REPLACES the <variant-selects> markup and does NOT fire shopify:section:load — so the JS picker
  // would de-initialise (the imaged pill reverts to a plain flat <select>). Re-run init() whenever the
  // DOM changes; init() is idempotent (guarded by the __nvc/__nvcdd flags on each element), and the new
  // (flagless) elements from the re-render get re-initialised. Debounced to once per frame.
  var _reinitQueued = false;
  function scheduleInit() {
    if (_reinitQueued) return; _reinitQueued = true;
    // setTimeout (NOT requestAnimationFrame): rAF is paused in background/hidden tabs, which would leave
    // _reinitQueued stuck true and stop the picker from ever re-initialising after a variant change.
    setTimeout(function () { _reinitQueued = false; init(); }, 50);
  }
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleInit(); break; } }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
